<div class="d-flex justify-content-center mt-4 lh-1" *ngIf="!loading">
  <ng-container *ngIf="!getGDPRLink()">
    <a target="_blank"
       class="footer-link text-{{ color }} text-decoration-none border-end border-secondary fs-6 px-2 px-xl-3"
       href="https://www.advofin.at/datenschutzerklaerung/">Datenschutz</a>
  </ng-container>
  <ng-container *ngIf="getGDPRLink()">
    <a target="_blank" class="footer-link text-{{ color }}  text-decoration-none border-end border-secondary fs-6 px-2 px-xl-3"
       href="{{getGDPRLink()}}">Datenschutz</a>
  </ng-container>

  <a target="_blank" class="footer-link text-{{ color }}  text-decoration-none border-end border-secondary fs-6 px-2 px-xl-3"
     href="https://www.advofin.at/ueber-advofin/">Über Advofin</a>

  <a target="_blank" class="footer-link text-{{ color }} text-decoration-none fs-6 px-2 px-xl-3"
     href="https://www.advofin.at/kontakt/">Kontakt</a>
</div>
